<template>
  <v-container class="edit-container px-10" fluid>
    <v-popup-loading :isLoading="isLoading" />
    <v-alert-error :show="isError" :close="closeAlert"></v-alert-error>
    <v-alert-success :show="isSuccess" :close="closeAlert"></v-alert-success>
    <alert-confirm
      :show="isCancel"
      title="Discard changes"
      subTitle="Are you sure you want to discard all changes?"
      headline-color="black"
      buttonCancel="OK"
      buttonText="Cancel"
      :close="onCancel"
      :confirm="closeCancelPopup"
      icon=""
    ></alert-confirm>
    <v-row class="mb-4">
      <v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          divider=">"
          class="px-0"
        ></v-breadcrumbs>
        <v-row class="align-center mr-0" style="margin-left: 1px">
          <h3 class="pageHeadline" t-data="page-headline">
            {{ textMode }} Appointment
          </h3>
          <v-spacer></v-spacer>
          <edit-buttons
            class="mt-3"
            :show-remove="false"
            :show-preview="false"
            :show-save="!disabledEdit"
            :on-cancel="showCancelPopup"
            :on-save="onSave"
          />
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-form ref="form" lazy-validation>
          <v-card>
            <v-card-title class="mt-0 pt-0 pb-0" t-data="card-title">
              <h6 class="mb-0 card-title" t-data="info-title">
                Edit Status
              </h6>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-0">
              <v-row align="start" justify="start" class="mt-0 px-2 mb-3">
                <v-col cols="12" t-data="info-input">
                  <p class="edit-field-label sub-body-bold" t-data="info-label">
                    Status<span class="danger500Color--text">*</span>
                  </p>
                  <v-select
                    outlined
                    dense
                    class="can-disable-selector selector-hide-detail"
                    v-model="appointmentObject.is_status"
                    :placeholder="disabledEdit ? '' : 'Select Status'"
                    :menu-props="{bottom: true, offsetY: true}"
                    :items="statusOptions"
                    item-value="value"
                    item-text="label"
                    :disabled="disabledEdit"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="start" justify="start" class="mt-0 px-2">
                <v-col cols="12" t-data="info-input">
                  <span
                    class="edit-field-label sub-body-bold"
                    t-data="info-label"
                  >
                    Remark
                  </span>
                  <v-textarea
                    class="can-disable-selector"
                    :placeholder="disabledEdit ? '' : 'Enter note here ...'"
                    outlined
                    dense
                    required

                    v-model="appointmentObject.remark"
                    :disabled="disabledEdit"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      <v-card class="mt-5">
        <v-card-title class="mt-0 pt-0 pb-0" t-data="card-title">
            <h6 class="mb-0 card-title" t-data="info-title">
              Patient Information
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-0 mx-4 patient-info">
             <v-row>
               <v-col :cols="item.col" v-for="item in patientInfos" :key="item.key">
                <p
                  class="body-2 mb-0 customer-information-label body-regular"
                  t-data="patient-info-label"
                >
                  {{ item.label }}
                </p>
                <p class="body-2 mb-0 information-text edit-field-label sub-body-bold pr-2" t-data="patient-info-value">
                  {{ getByPath(appointmentObject, item.key) }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="mt-0 pt-0 pb-0" t-data="card-title">
            <h6 class="mb-0 card-title" t-data="info-title">
              Appointment Information
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-0 mx-4 patient-info">
             <v-row>
               <v-col :cols="item.col" v-for="item in aptInfos" :key="item.key">
                <p
                  class="body-2 mb-0 customer-information-label body-regular"
                  t-data="apt-info-label"
                >
                  {{ item.label }}
                </p>
                <p class="body-2 mb-0 information-text sub-body-bold pr-2" t-data="apt-info-value">
                  <span v-if="item.key ==='user_package' && appointmentObject.user_package !== null">
                    <span class="edit-field-label">
                      {{ getByPath(appointmentObject, item.key).package_name }}
                    </span>
                    <br>
                    <span class="customer-information-label">
                      {{ getByPath(appointmentObject, item.key).sub_package_name }}
                    </span>
                  </span>
                  <span v-else-if="item.key ==='apt_files'">
                    <template v-for="(file, index) in appointmentObject.apt_files">
                      <a class="info600Color--text" :key="index" :href="file" target="_blank" rel="noopener noreferrer">
                        {{ file.split('/').pop().split('?')[0] }}
                      </a>
                    </template>
                  </span>
                  <span class="edit-field-label" v-else>
                    {{ getByPath(appointmentObject, item.key) }}
                  </span>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        <v-card-text class="mt-0">
        </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
        <v-card-title class="mt-0 pt-0 pb-0" t-data="card-title">
          <h6 class="mb-0 card-title" t-data="info-title">
            History
          </h6>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-0">
            <v-row class="body-bold mt-3 mb-3">
              <v-col
                cols="3"
                class="no-top-bottom-space py-0"
                t-data="history-header"
                >Updated date, time</v-col
              >
              <v-col
                cols="3"
                class="no-top-bottom-space py-0 text-start"
                t-data="history-header"
                >Updated by</v-col
              >
              <v-col
                cols="2"
                class="no-top-bottom-space py-0 text-center"
                t-data="history-header"

                >Status</v-col
              >
              <v-col
                cols="4"
                class="no-top-bottom-space py-0 text-start"
                t-data="history-header"
                >Remark</v-col
              >
            </v-row>
            <v-row><v-divider></v-divider></v-row>
            <div v-if="appointmentObject.audit_logs.length > 0">
              <template v-for="(item, index) in appointmentObject.audit_logs">
                <history-item
                  :key="index"
                  :item="item"
                  :class="{'mb-2': index + 1 < appointmentObject.audit_logs.length}"
                ></history-item>
                <v-row :key="`info-${index}`">
                  <v-divider
                    v-if="index + 1 < appointmentObject.audit_logs.length"
                  ></v-divider>
                </v-row>
              </template>
            </div>
            <v-row v-else>
              <v-col class="text-center">
                -
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="d-flex align-start mr-0 mb-3" style="margin-left: 1px">
      <v-row class="align-center mt-2" style="margin-left: 1px; margin-right: 0;">
        <div class="edit-by-content sub-body-regular" t-data="create-by-content">
          Created Date and Time, {{ dateFmt(appointmentObject.created_at) }}
        </div>
        <v-spacer></v-spacer>
      </v-row>
      <v-spacer></v-spacer>
      <edit-buttons
        class="mt-3"
        :show-remove="false"
        :show-preview="false"
        :show-save="!disabledEdit"
        :on-cancel="showCancelPopup"
        :on-save="onSave"
      />
    </v-row>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import moment from 'moment'
import PopupLoading from '@/components/PopupLoading'
import AlertSuccess from '@/components/AlertSuccess'
import AlertError from '@/components/AlertError'
import AlertConfirm from '@/components/AlertConfirm'
import EditButtons from '@/components/EditButtons'
import HistoryItem from '@/components/appointment/HistoryItem'
import {
  snackbarSuccessContent,
  snackbarFailContent,
  hasPermissionsByOrgs,
  convertDateBirthDate,
  convertDate
} from '@/helper/helper'
import {displayTypeDetailText, genderText, prefixText, statusTextOption} from '@/constants/appointment'

export default {
  components: {
    'v-alert-success': AlertSuccess,
    'v-alert-error': AlertError,
    'v-popup-loading': PopupLoading,
    AlertConfirm,
    EditButtons,
    HistoryItem,
  },
  name: 'Edit',
  data() {
    return {
      snackTitle: '',
      pageName: 'Appointment',
      isCreateSuccess: false,
      isCreateFail: false,
      isEditMode: false,
      isCancel: false,
      isError: false,
      isSuccess: false,
      linkroute: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/'
        },
        {
          text: 'Appointments List',
          disabled: false,
          href: '/appointment-list'
        },
        {
          text: this.textMode,
          disabled: true,
          href: '/'
        }
      ],
      patientInfos: [
        {col: 6, key: 'customer.prefix', label: 'Title'},
        {col: 6, key: 'customer.fullname', label: 'Patient name'},
        {col: 6, key: 'customer.nationality', label: 'Nationality'},
        {col: 6, key: 'customer.id_card_no', label: 'ID card no./Passport no.'},
        {col: 6, key: 'customer.gender', label: 'Gender'},
        {col: 6, key: 'customer.birthdate', label: 'Date of birth'},
        {col: 6, key: 'customer.phone', label: 'Contact number'},
      ],
      aptInfos: [
        {col: 6, key: 'org.name', label: 'Hospital name'},
        {col: 6, key: 'department.department_name', label: 'Department name'},
        {col: 6, key: 'doctor.name', label: 'Care provider'},
        {col: 6, key: 'appointmentDateTime', label: 'Appointment date, time'},
        {col: 6, key: 'display_type', label: 'Channel'},
        {col: 6, key: 'customer.contact_time', label: 'Contact time'},
        {col: 12, key: 'user_package', label: 'For package'},
        {col: 12, key: 'apt_description', label: 'Symptom'},
        {col: 12, key: 'apt_files', label: 'Attachment'},
      ]
    }
  },

  computed: {
    snackbarSuccess() {
      return snackbarSuccessContent(this.pageName, this.snackTitle)
    },
    snackbarFail() {
      return snackbarFailContent(this.pageName, this.snackTitle)
    },
    disabledEdit() {
      return (
        this.isEditMode &&
        !hasPermissionsByOrgs('CanEditAppointments', [this.appointmentObject.org_codename])
      )
    },
    textMode() {
      return this.isEditMode ? 'Edit' : 'Create'
    },
    breadcrumbs() {
      return [
        {text: 'Dashboard', links: true, to: '/'},
        {text: 'Appointment', links: true, to: '/appointments'},
        {text: this.textMode, links: false}
      ]
    },
    statusOptions() {
      const status = []

      for (let key in statusTextOption) {
        if (statusTextOption.hasOwnProperty(key)) {
          status.push({label: statusTextOption[key], value: key})
        }
      }
      return status
    },
    ...mapState('appointment', [
      'appointmentObject',
      'isLoading',
    ])
  },
  beforeRouteLeave(to, from, next) {
    next()
    this.resetState()
    this.resetList()
  },
  async created() {
    this.fetchDetails()
  },
  mounted() {
    let query = this.$route.query.isCreateSuccess
    let querySnackTitle = this.$route.query.snackTitle

    if (query) {
      this.$router.replace({})
      this.isCreateSuccess = query
      this.snackTitle = querySnackTitle
    }
  },
  watch: {
    $route: function() {
      this.fetchDetails()
    },
  },
  methods: {
    dateFmt: date => convertDate(date),
    async fetchDetails() {
      this.isEditMode = !!this.$route.params.id
      if (this.isEditMode) {
        await this.setAppointmentId(this.$route.params.id)
        // scroll to top
        window.scrollTo(0, 0)
      } else {
        this.resetState()
      }
    },
    onCreatedCancel() {
      this.$router.push({
        name: 'appointment-list',
        query: {isCreateSuccess: true, snackTitle: 'created'}
      })
    },
    showSuccessSnackbar(action) {
      this.isCreateSuccess = true
      this.snackTitle = action
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    showCancelPopup() {
      this.isCancel = true
    },
    closeCancelPopup() {
      this.isCancel = false
    },
    onCancel() {
      this.$router.push({
        name: 'appointment-list'
      })
    },
    showFailSnackbar(action) {
      this.isCreateFail = true
      this.snackTitle = action
    },
    getByPath(obj, path, defaultValue = '-') {
      const value = path.split('.').reduce((o, key) => {
        return o ? o[key] : undefined;
      }, obj);
      if (value === undefined || value === null || value === '') {
        return defaultValue
      }
      if (path === 'customer.prefix') {
        return prefixText[value]
      }
      if (path === 'customer.birthdate') {
        return convertDateBirthDate(value)
      }
      if (path === 'customer.gender') {
        return genderText[value]
      }
      if (path === 'appointmentDateTime') {
        return moment.utc(value).format('DD/MM/YYYY HH:mm');
      }
      if (path === 'display_type') {
        return displayTypeDetailText[value]
      }
      return value;
    },
    async onSave() {
      const status = await this.updateAppointment({
        id: this.$route.params.id,
        pkg: this.appointmentObject
      })
      if (status) {
        this.$router.push({
          name: 'appointment-list',
          query: {isCreateSuccess: true, snackTitle: 'edited'}
        })
      } else {
        return (this.isError = true)
      }
    },
    closeAlert() {
      this.isError = false
      this.isSuccess = false
    },
    resetErrorMsg() {
      this.setCodeErrorMessage('')
    },
    ...mapActions('appointment', [
      'resetList',
      'resetState',
      'setAppointmentId',
      'updateAppointment',
    ])
  }
}
</script>

<style>
.selector-hide-detail > .v-input__control > .v-text-field__details {
  display: none;
}

.patient-info > .row > .col > .body-2 {
  line-height: 28px !important;
}
</style>
